import { render, staticRenderFns } from "./CreatePopup.vue?vue&type=template&id=1fdf8f1b"
import script from "./CreatePopup.vue?vue&type=script&lang=js"
export * from "./CreatePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports